import * as React from 'react';

export type TaskOption = {
  id: string;
  label: string;
  description?: string;
};

export type TaskChooserProps = {
  title?: string;
  options: TaskOption[];
  onSelect: (id: string) => void;
  disabled?: boolean;
};

/**
 * Landing card for the Assist-Me flows: presents context-derived task options (create / edit / manage /
 * …) so the agent doesn't assume "create". The chat input is always available for freeform, so this is
 * one of two ways to start; picking a task seeds the agent with the chosen intent.
 */
export function TaskChooser({
  title = 'What would you like to do?',
  options,
  onSelect,
  disabled
}: TaskChooserProps): JSX.Element {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-gray-800">{title}</h3>
      <div className="space-y-2">
        {options.map(option => (
          <button
            key={option.id}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(option.id)}
            className="block w-full rounded-lg border border-primary/30 bg-white px-4 py-3 text-left transition-colors hover:border-primary/50 hover:bg-primary/5 disabled:cursor-not-allowed disabled:opacity-50">
            <div className="text-sm font-medium text-gray-900">{option.label}</div>
            {option.description ? (
              <div className="mt-0.5 text-xs text-gray-500">{option.description}</div>
            ) : null}
          </button>
        ))}
      </div>
      <p className="mt-3 text-xs text-gray-400">…or just type what you need in the chat.</p>
    </div>
  );
}
